import WSingleBarSimple from './charts/bar/WSingleBarSimple'
import WSingleBarBasic from './charts/bar/WSingleBarBasic'
import WSingleBarComplex from './charts/bar/WSingleBarComplex'
import WMultipleBarSimple from './charts/bar/WMultipleBarSimple'
import WMultipleBarBasic from './charts/bar/WMultipleBarBasic'
import WMultipleBarComplex from './charts/bar/WMultipleBarComplex'

const Components = {
	WSingleBarSimple,
	WSingleBarBasic,
	WSingleBarComplex,
	WMultipleBarSimple,
	WMultipleBarBasic,
	WMultipleBarComplex
}

export default Components
